import React, { useContext } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { UseEklok } from "../../api/eklok/Eklok.api";

const DetailEklokContainer = ({ id, children }) => {
  const { token } = useContext(AuthContext);
  const { content, loading, error } = UseEklok(token, id);

  return (
    <>
      {error ? <Error message={error.message} /> : null}
      {loading ? <Loading /> : null}
      {content ? children({ content }) : null}
    </>
  );
};

export default DetailEklokContainer;
